import React, { Component } from 'react'
import { connect } from 'react-redux'
import '../../../styles/checkout/mainStyle.css'
import { toggleDisplayIframe ,updateCallbackConsole} from '../../../actions/checkoutActions'
import Iframe from 'react-iframe'
import CallBack from './CallBack'

export class IframePage extends Component {
    
    state = {
        vww: window.parent.innerWidth/2+ 50 + 'px',
        vhh: this.props.ticket==="No CallBack Yet" && this.props.ticket===""? window.parent.innerHeight + 90+ 'px': window.parent.innerHeight + 'px'
    };

    constructor(props) {
        super(props);
        this.componentDidUpdate = this.componentDidUpdate.bind(this)
        this.returnDataFormatted = this.returnDataFormatted.bind(this)
    }

    componentDidUpdate() {
        const { ticket, ifDisplayIframe, ifTerminateCheckout, ifDisplayCheckout } = this.props;
        if (ifDisplayIframe) {
            const data = {
                "ticket": ticket,
                "ifDisplayCheckout": ifDisplayCheckout,
                "ifTerminateCheckout": ifTerminateCheckout
            }
            const childFrameObj = document.getElementById('myId');
            childFrameObj.contentWindow.postMessage(data, '*'); //window.postMessage
        }
    }

     returnDataFormatted = (data ,title) =>{
        var today = new Date();
        let time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds() + '\n';
        var x;
        var dataFormatted = title+ ":          "+ time;
      
        for (x of data) {
          if (x === '{') {
            dataFormatted += '\n'  
          } else if (x === ',') {
            dataFormatted += ',\n'
          } else if (x === '}'){
            dataFormatted += '\n}' 
          } else {
            dataFormatted += x;
          }
        }
      
        return dataFormatted;
      }
      
    componentDidMount() {
        const receiveMessageFromIndex = function (event) {
            let event_JSON = ""
            //here we are not sure about the error Unexpected token o in JSON at position 1
            try {
                event_JSON = JSON.parse(event.data);
              }
              catch(err) {
              }
            if (event !== undefined && event_JSON.handler) {
                const message = this.returnDataFormatted(event.data , event_JSON.handler)
                this.props.updateCallbackConsole( message)
            }
        }.bind(this)
        window.addEventListener("message", receiveMessageFromIndex, false);
    };

    render() {
        return (
            <div style={{ display: this.props.ifDisplayIframe ? 'inline' : 'none'}}>
                <div className="merChantTitleBar2" style={{width: '100%'}}>
                    <div className="merChantTitleText2">The merchant’s checkout page</div>
                </div> 
                <Iframe 
                    url="../../../checkout.html"
                    width="100%"
                    // height="100%"
                    height={this.props.callBackConsole[0]!=="No CallBack Yet" ? window.parent.innerHeight + 900+ 'px': window.parent.innerHeight -10+ 'px'}
                    id="myId"
                    className="iframeClass2"
                    display="initial"
                    position="relative"
                    frameBorder="0"
                />
                <CallBack/>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { PreoloadPrequestResponse, ifDisplayIframe, ticket, ifDisplayCheckout, ifTerminateCheckout, callBackConsole } = state.checkout.main;
    return { PreoloadPrequestResponse, ifDisplayIframe, ticket, ifDisplayCheckout, ifTerminateCheckout, callBackConsole};
}

export default connect(mapStateToProps, { toggleDisplayIframe,updateCallbackConsole })(IframePage)
